/* eslint-disable @typescript-eslint/no-non-null-assertion */

import cn from 'classnames';
import * as React from 'react';
import Select from 'react-select';
import util from 'util';

import {
  dayOfTheMonthOptions,
  DayOfTheMonthSelectOption,
  DayOfTheMonthSelectSingleValue,
  dayOfTheMonthSelectStyles,
  getDayOfTheMonthLabel,
  UserSelectDropDownIndicator,
} from '../../select-styles';

export const SelectDayOfTheMonth = ({
  handleChangeMonth,
  interval,
}: {
  handleChangeMonth: ({ value }) => void;
  interval: string;
}) => {
  const handleChange = (option) => {
    handleChangeMonth(option.value);
  };

  return (
    <div>
      <label htmlFor="assigner" className={cn('text-sm text-gray-500 font-medium', {})}>
        On the date
      </label>
      <Select
        options={[
          {
            label: 'On the date',
            options: dayOfTheMonthOptions(),
          },
        ]}
        menuPortalTarget={document.body}
        // isDisabled={item?.isReadOnly || item?.access === 'view' || boardsStore.isPublicView}
        onChange={handleChange}
        value={{ label: getDayOfTheMonthLabel(interval), value: interval }}
        styles={dayOfTheMonthSelectStyles}
        menuPlacement="bottom"
        placeholder="select"
        className="mt-14"
        components={{
          DropdownIndicator: UserSelectDropDownIndicator,
          IndicatorSeparator: () => null,
          SingleValue: DayOfTheMonthSelectSingleValue,
          Option: DayOfTheMonthSelectOption,
        }}
      />
    </div>
  );
};
